import React from 'react';
import { Avatar, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

export const IncidentReportNotification = ({
	notification,
	handleAcknowledgeMaydayMessage,
	userTimeZone,
	handleCloseMenu,
	setNotifications,
	notifications,
}) => {
	const navigate = useNavigate();
	const handleAcknowledge = () => {
		handleAcknowledgeMaydayMessage(notification);
		navigate(`/students/incident-reports/view/${notification?.data?.data?.incident_id}`);
		handleCloseMenu();
		setNotifications(notifications.filter((noti) => noti.auto_id !== notification.auto_id));
	};

	return (
		<Table key={notification.auto_id}>
			<TableBody>
				<TableRow>
					<TableCell
						className="notification-wrapper"
						style={{
							backgroundColor: `${notification.deleted_at ? '' : '#F0F9FE'}`,
							width: '450px',
						}}
					>
						<div className="flex" style={{ gap: '5px' }}>
							<div className="">
								<Avatar
									src={notification?.room?.thumb || 'assets/images/schoolAdminTopNav/noti-icon.svg'}
									style={{ width: '35px', height: '35px' }}
								/>
							</div>
							<div className="flex flex-col" style={{ flexGrow: 1 }}>
								<span className="font-bold" style={{ fontSize: '14px', marginBottom: '4px' }}>
									{notification?.room?.name}
								</span>
								<span style={{ fontSize: '12px' }}>
									<span>{notification?.data?.body}</span>
								</span>
							</div>
							<div className="flex flex-col items-end gap-10" style={{ flexShrink: 0 }}>
								<span style={{ fontSize: '11px', marginTop: '4px' }}>
									{dayjs.utc(notification.created_at).tz(userTimeZone).format('MMMM D, YYYY, hh:mm A')}
								</span>
								{notification.deleted_at === null ? (
									<CustomButton onClick={handleAcknowledge}>View</CustomButton>
								) : null}
							</div>
						</div>
					</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	);
};
